import facilityForm from './facilityForm';
import form from './form';
import table from './table';

export default {
  layout: 'employment-layout',
  form,
  table,
  facilityForm,
};
